import { Gender } from '@/types';

/**
 * Gets the Spanish label for a gender
 */
export const getGenderLabel = (gender: Gender | string): string => {
  switch (gender) {
    case Gender.MALE:
    case 'MALE':
      return 'Masculino';
    case Gender.FEMALE:
    case 'FEMALE':
      return 'Femenino';
    case Gender.MIXED:
    case 'MIXED':
      return 'Mixto';
    case Gender.ANY:
    case 'ANY':
      return 'Abierto';
    case 'OTHER':
      return 'Otro';
    default:
      // Return 'Otro' for any unknown gender value instead of showing the raw value
      return 'Otro';
  }
};
